export default "__VITE_ASSET__CKRavSjP__"